<template>
  <div class="nettdoc-pain-detail">
    <SectionHeader 
      text="I have pain" 
      img="illu-card-beschwerden-pain" 
      alt="Lightning for pain" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.painDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Since when are you with/in pain?" :dark="true" :required="true" />
      <Dropdown 
        label="please choose"
        :data="['For a few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month', 'Always']"
        :choice="store.painDetails.since"
        v-on:action="value => store.addPainDetails('since', value)"
      />

      <SectionHeader text="When do you feel the pain?" :dark="true" :required="true" />
      <Dropdown 
        label="please choose"
        :data="['At night', 'In the morning', 'At noon', 'In the evening', 'Always']"
        :choice="store.painDetails.when"
        v-on:action="value => store.addPainDetails('when', value)"
      />

      <SectionHeader text="trigger" :dark="true" :required="true" />
      <Dropdown 
        label="please choose"
        :data="['Fall', 'Accident', 'Other injury', 'No', 'I don\'t know']"
        :choice="store.painDetails.trigger"
        v-on:action="value => store.addPainDetails('trigger', value)"
      />

      <SectionHeader text="painDependingOnSituation" :dark="true" :required="false" />
      <YesNo 
        :model="store.painDetails.painDependingOnSituation"
        v-on:action="value => store.addPainDetails('painDependingOnSituation', value)"
      />
      <template v-if="store.painDetails.painDependingOnSituation === 'yes'">
        <SectionHeader text="painSituation" :dark="true" :required="false" />
        <Dropdown 
          label="please choose"
          :data="['While eating', 'After eating', 'While using the restroom', 'While moving', 'While breathing more intense than normal', 'While swollowing', 'At rest']"
          :choice="store.painDetails.painSituation"
          v-on:action="value => store.addPainDetails('painSituation', value)"
        />
      </template>

      <SectionHeader text="How do you describe the pain?" :dark="true" :required="true" />
      <Dropdown 
        label="please choose"
        :data="['Constant', 'pulsatile', 'dull', 'burning', 'penetrative', 'diffuse', 'Crampy/ spasmodic']"
        :choice="store.painDetails.quality"
        v-on:action="value => store.addPainDetails('quality', value)"
      />

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.painDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import Button from "../Button";
import Dropdown from "../Dropdown";
export default observer({
    name: 'Pain',
    data() {
      return {
        collapsed: true
      };
    },
    props: {
      store: Object,
      edit: Boolean
    },
    components: {
      SectionHeader, YesNo, Button, Dropdown
    },
    methods: {
    submit: function() {
      this.store.painDetails.submitted = true
      localStorage.setItem(
        "painDetails",
        JSON.stringify(this.store.painDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>